module.exports = __webpack_public_path__ + "img/vegetable-fennel-350x184.9436177e.jpg";